import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import styled from "@emotion/styled";
import Cookies from 'js-cookie';
import { Input, Col, Row, Select } from "antd";

import VocalSelection, { VocalType } from "../components/VocalSelection";
import MySlider, { range } from "../components/Slider/Slider";
import Login from "../components/Login/Login";
import { TtsGenerateParam } from "../service/AIapi";
import VoiceService, { TtsApiPath } from '../service/VoiceService';
import { AudioPlaybackBar } from '../components/AudioPlaybackBar';
import Describe from '../components/Describe/Describe';
import { SoundSynthesisDescribeData } from '../components/staticDescribeData';

import './style.scss';
const { TextArea } = Input;

// 播放器一共有5个状态
//
// 1. 未播放
// 2. 播放中
// 3. 暂停了
// 4. 继续播放
// 5. 播完了重播

// 下面的按钮有：
// 1. 立即合成
// 2. 合成中
// 3. 停止播放
// 4. 继续播放
// 5. 重播

const PlayerStatus = {
    start: '立即合成',
    done: '已合成',
    running: '合成中',
    stop: '合成中',
    resume: '继续播放',
    replay: '重播',
}

const SoundSynthesis = (): React.ReactElement => {
    const [isLogin, setIsLogin] = useState(!!Cookies.get('access_token'));
    const login = useSelector((state: any) => state?.guard?.isLogin);
    const [select, setSelected] = useState(0)
    const [currentObject, setCurrenyObject] = useState()
    const [volume, setVolume] = useState<number>(50);
    const [speed, setSpeed] = useState<number>(0)
    const [loading, setLoading] = useState<boolean>(false)
    const [btnText, setBtnText] = useState<string>(PlayerStatus.start)
    const [remain, setRemain] = useState<number>(300)
    const [input, setInput] = useState('')

    const [typeList, setTypeList] = useState<Array<VocalType>>([])
    const [filterVoiceGender, setFilterVoiceGender] = useState('All');
    const [audioSrc, setAudioSrc] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('static/voices_vaas.json');
                const jsonData = await response.json();
                let temp: Array<VocalType> = [];

                jsonData.forEach((item: any, index: number) => {
                    temp.push({
                        nickname: item.nickname,
                        voice_id: item.voice_id,
                        voice_type: item.voice_type,
                        gender: item.gender,
                        avatar_url: item.avatar_url,
                        default_text: item.default_text
                    }
                    )
                })
                setTypeList(temp);
                setInput(temp[0].default_text);
                setRemain(300 - temp[0].default_text.length)
            } catch (error) {
                if (error.message === "Request failed with status code 504"
                    || error.message === "Request failed with status code 502"
                ) {
                    alert('获取音色列表失败：\n    1、如果目前服务正在启动，请稍后再试。\n    2、如果持续此状态超过3分钟，请参考使用说明书进行排查。')
                }
                else {
                    // Handle other possible errors here
                    alert('未知错误: ' + JSON.stringify(error));
                }
            }
        };
        fetchData()
        setIsLogin(!!Cookies.get('access_token'))
    }, [])
    useEffect(() => {
        setIsLogin(!!Cookies.get('access_token'))
    }, [login])

    const ChangeVolume = (vol: number) => {
        setVolume(vol);
        setLoading(false);
        setBtnText(PlayerStatus.start);
    }

    const ChangeSpeed = (speed: string) => {
        setLoading(false);
        setBtnText(PlayerStatus.start);
        let rate: number = range[speed.slice(0, -1)][0];
        setSpeed(rate)
    }

    const changeVocal = (index: number, vocal: any) => {
        setCurrenyObject(vocal)
        setSelected(index);
        setInput(typeList[index].default_text);
        setRemain(300 - typeList[index].default_text.length)

        setLoading(false);
        setBtnText(PlayerStatus.start);
    }

    const GenerateAudio = () => {

        const speechParam: TtsGenerateParam = {
            text: input,
            voice: typeList[select].voice_id,
            volume: Number(volume),
            speech_rate: speed,
            source: 2,
        }

        VoiceService.post(`${TtsApiPath}/generate`, speechParam, { responseType: 'blob' }).then(res => {
            setLoading(false);
            let blob = new Blob([res.data], { type: 'audio/wav' })
            setAudioSrc(URL.createObjectURL(blob));
            setBtnText(PlayerStatus.done);
        })
            .catch(error => {
                if (error.response && error.response.status === 500) {
                    const reader = new FileReader();
                    reader.onload = function () {
                        // The result attribute contains the contents of the blob as a text string
                        console.log(this.result);
                        alert(`服务端错误（请保留错误信息，反馈给相关技术支持人员）:\n${this.result}`);
                    };
                    reader.readAsText(error.response.data);
                } else if (error.response && error.response.status === 400) {
                    const reader = new FileReader();
                    reader.onload = function () {
                        // The result attribute contains the contents of the blob as a text string
                        console.log(this.result);
                        alert(`客户端错误（请根据以下错误信息，修改输入内容）:\n${this.result}`);
                    };
                    reader.readAsText(error.response.data);
                } else if (error.message === "Request failed with status code 504"
                    || error.message === "Request failed with status code 502") {
                    alert('服务异常：请参考使用说明书进行排查')
                }
                else {
                    // Handle other possible errors here
                    alert('未知错误: ' + error.message);
                }
                setLoading(false);
                setBtnText(PlayerStatus.start);
            })
            .finally(() => {

            });
    }

    const GenerateSpeech = () => {
        switch (btnText) {
            case PlayerStatus.stop:
                // audio.pause();
                setBtnText(PlayerStatus.resume);
                break;
            case PlayerStatus.start:
                GenerateAudio();
                setLoading(true);
                setBtnText(PlayerStatus.running);
                break;
            case PlayerStatus.resume:
                setBtnText(PlayerStatus.stop);
                // audio.play();
                break;
            case PlayerStatus.replay:
                // audio.play();
                setBtnText(PlayerStatus.stop);
                break;
            default:
                break;
        }
    }

    const ChangeInput = (e: any) => {
        setInput(e.target.value);
        setRemain(300 - e.target.value.length);
        setLoading(false);
        setBtnText(PlayerStatus.start);
    }

    const HandleSelectChange = async (value: string) => {
        setFilterVoiceGender(value);
        const filteredList = typeList.filter(item => value === 'All' || item.gender === value);
        const selectDataIndex = filteredList.findIndex(it => it === currentObject);

        setSelected(selectDataIndex > -1 ? selectDataIndex : 0);
        setInput(filteredList[selectDataIndex]?.default_text || filteredList[0]?.default_text);
    };

    const isEmptySourceText = () => {
        return !input || !isLogin;
    }
    const colCount = 3;
    return (
        <>
            <DescribeDiv>
                {SoundSynthesisDescribeData?.map((item, index) => {
                    return < Describe data={item} index={index} />
                })}
            </DescribeDiv>
            < SoundFrame >
                <Container>
                    <SoundContainer>
                        <SoundTitle>场景</SoundTitle>
                        <Select
                            defaultValue="All"
                            variant={"borderless"}
                            style={{ marginRight: "4px", float: "right", color: '#666666', fontSize: 12, marginTop: '-5px' }}
                            onChange={HandleSelectChange}
                            options={[
                                { value: 'All', label: '全部' },
                                { value: 'Female', label: '女声' },
                                { value: 'Male', label: '男声' },
                            ]}
                        />
                        <SoundCardContainer>
                            <TypeListDiv>
                                <Row gutter={[16, 0]}>
                                    {typeList.filter(item => filterVoiceGender === 'All' || item.gender === filterVoiceGender).map((item, i) =>
                                        <Col style={{ marginBottom: 20, }} key={i.toString()} span={24 / colCount}>
                                            <VocalSelection key={`type-${i}`} vocal={item} index={i} isSelected={i === select} click={changeVocal} />
                                        </Col>,
                                    )}
                                </Row>
                            </TypeListDiv>
                        </SoundCardContainer>
                    </SoundContainer>
                    <TextContainer>
                        <SoundTitle style={{ marginTop: 20, marginBottom: 12 }}>示例文本</SoundTitle>
                        <InputArea>
                            <TextArea maxLength={300} style={{
                                padding: 20,
                                resize: "none",
                                width: "100%",
                                height: "100%",
                                background: "#F6F6F6",
                                borderRadius: 2
                            }} variant={"borderless"} onChange={ChangeInput} value={input} />
                            <AreaTip>体验版还可以输入 <span style={{ color: "#FF671D" }}>{remain}</span> 个字，超出部分合成将被截断</AreaTip>
                        </InputArea>
                        <ConfigDiv>
                            <VolumeDiv>
                                <SoundTitle>音量</SoundTitle>
                                <MySlider sliderWidth={344} state={'compound'} initVal={volume} change={ChangeVolume} type="vol" />
                            </VolumeDiv>
                            <VolumeDiv style={{ marginBottom: 55, marginTop: 5 }}>
                                <SoundTitle>语速</SoundTitle>
                                <MySlider sliderWidth={344} state={'compound'} initVal={speed} change={ChangeSpeed} type="speed" />
                            </VolumeDiv>
                        </ConfigDiv>
                    </TextContainer>
                </Container>
                {AudioPlaybackBar(isEmptySourceText, loading, GenerateSpeech, btnText, audioSrc)}
            </SoundFrame >
            <Login></Login>
        </>
    );
}

export default SoundSynthesis;

const DescribeDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    margin-top: 60px;
    height: 198px;
`

const SoundContainer = styled.div`
//   background-color: lightblue;
    flex: 1;
`

const SoundCardContainer = styled.div`
//   background-color: orange;
  max-height: 94%;
  overflow-x: clip !important;
  /* padding: 0 10px; */
  margin: 0px 0px 17px 0;
  
`

const TextContainer = styled.div`
//   background-color: lightgreen;
  width: 442px;
  padding-left: 20px;
`

const Container = styled.div`
  display: flex;
  grid-template-columns: 1fr 1fr;
  /* grid-gap: 10px; */
`

const SoundFrame = styled.div`
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0 30px 40px 0 rgba(0, 0, 0, 0.06);
  border-radius: 6px;
//   margin-top: 60px;
  padding: 20px;
  display: flex;
  flex-direction: column;
`

const SoundTitle = styled.span`
  font-size: 16px;
  color: #222222;
  line-height: 16px;
  font-weight: 600;

`

const TypeListDiv = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: left;
  margin-top: 12px;
`

const InputArea = styled.div`
  width: 100%;
  height: 198px;
  position: relative;
  padding-top: 12px;
`

const AreaTip = styled.span`
  position: absolute;
  left: 20px;
  bottom: 20px;

  font-size: 12px;
  color: #999999;
  line-height: 12px;
  font-weight: 400;
`

const ConfigDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 20px;

`
const VolumeDiv = styled.div`
  width: 100%;
  height: 100px;
//   margin-top: 12px;
`
// const useStyles = createStyles({
//     box: {
//         display: 'flex',
//         alignItems: 'center',
//         flexDirection: 'column'
//     },
//     mobalBox: {
//         '.ant-modal-content': {
//             padding: '26.82px 30px'
//         }
//     },
//     title: {
//         fontSize: 20,
//         fontWeight: 600,
//         lineHeight: 'normal',
//         color: '#222222'
//     },
// });


